<ng-template ngFor let-item [ngForOf]="data" let-i="index">
  <ion-item button (click)="item.handler()">
    <ion-icon slot="start" [name]="item.icon"></ion-icon>
    <ion-label>
      {{ item.text }}
    </ion-label>
  </ion-item>
</ng-template>

<ion-item button (click)="dismissPopover()">
  <ion-icon slot="start" name="close-outline"></ion-icon>
  <ion-label> Cancel </ion-label>
</ion-item>
